import classNames from 'classnames';
import * as React from 'react';
import type { ReactNode } from 'react';
import { Button } from '../Button/Button';
import { ButtonTier } from '../Button/ButtonTier.csharp';
import { ButtonType } from '../Button/ButtonType.csharp';
import { List } from '../List/List';
import type { IdType } from '../Utils/typeUtils';
import { Collapse } from '~/Partials/Collapse/Collapse';
import styles from './CollapseList.module.css';
import type { CollapseListTranslations } from './CollapseListTranslations.csharp';

interface CollapseListProps<T> {
    initialLength: number;
    translations: CollapseListTranslations;
    items: ReadonlyArray<T>;
    renderItem: (item: T, index: number) => ReactNode;
    title?: string;
}

export const CollapseList = <T extends { id: IdType }>(props: CollapseListProps<T>) => {
    const { title, initialLength, translations, items, renderItem } = props;

    const [isCollapseOpened, setIsCollapseOpened] = React.useState(false);

    return (
        <div className={styles.CollapseList}>
            <div className={styles.Inner}>
                <div className={styles.Content}>
                    {title && <h2 className={styles.Title}>{title}</h2>}
                    <List
                        className={styles.List}
                        items={items.slice(0, initialLength)}
                        renderItem={(item, index) => <li key={item.id}>{renderItem(item, index)}</li>}
                    />
                    {items.length > initialLength && (
                        <>
                            <Collapse isOpen={isCollapseOpened} className={styles.ListWrapper}>
                                <List
                                    className={classNames(styles.List, styles.ExpandedList)}
                                    items={items.slice(initialLength)}
                                    renderItem={(item, index) => <li key={item.id}>{renderItem(item, index)}</li>}
                                />
                            </Collapse>
                            <Button
                                onClick={() => setIsCollapseOpened(!isCollapseOpened)}
                                type={ButtonType.Solid}
                                tier={ButtonTier.Primary}
                            >
                                {isCollapseOpened ? translations.showLess : translations.showAll}
                            </Button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
